
import React, { useState, useEffect } from "react";
import { Grid } from "@material-ui/core";
import "./Layout.scss";
import DropDown from "./../components/Select";
import { areaValue, cityValue, clearTest } from "../../src/redux/auth/actions";
import axios from 'axios'
import { useSelector, useDispatch } from "react-redux";
import { Card } from "react-bootstrap";


export default function Popup(props) {


  const [city, setcity] = useState([]);
  const [areaList, setAreaList] = useState([]);
  const [area, setArea] = useState([]);
  const [areaVal, setAreaVal] = useState('');
  const [arValue, setArValue] = useState('');
  const [partner, setPartner] = useState([]);
  const [partners, setPartners] = useState();
  const [ptValue, setPtValue] = useState('');
  const [filtrdata, setDataFilter] = useState([])
  const [areaName, setAreaName] = useState('');
  const [cityName, setCityName] = useState('');
  const [loc, setLocationLength] = useState([])
  const [names, setNames] = useState('')

  const dispatch = useDispatch();

  useEffect(() => {
    if (props && props.city) {
      let res = props.city.map((e, i) => {
        return { label: e.name, value: e.uuid };
      });
      setcity(res);
    }
  }, [props, props.city]);

  useEffect(() => {
    if (areaList && areaList.length !== 0) {
      let res = areaList.map((e, i) => {
        return { label: e.name, value: e.uuid };
      });
      setArea(res);
    }
  }, [areaList]);

  const handlearea = (city) => {
    console.log(city, "ddddddddd");
    // setArValue(null);
    const { value, label } = city;
    dispatch(cityValue({ value, label }));
    axios
      .get(`${process.env.REACT_APP_API_URL}/uploadDoc/getArea/${value}`)
      .then((res) => {
        setAreaList(res.data)
        console.log(res.data)
      });
  };
  // http://test-api.doctall.com/api/v1/metadata/partner/getpartner
  useEffect(() => {
    axios.get(`${process.env.REACT_APP_API_URL}/metadata/partner/getpartner`)
      .then((res) => {
        setPartner(res.data)
      })
      .catch((err) => {
        console.log(err)
      })
  }, [])
  useEffect(() => {

    axios.get(`${process.env.REACT_APP_API_URL}/uploadDoc/labpartner/details?area_uuid=${arValue}&city_uuid=${areaVal}&partner_uuid=${ptValue}`)
      // axios.get(`${process.env.REACT_APP_API_URL}/uploadDoc/labpartner/details?area_uuid=AR-DFD9991F&city_uuid=CY-25F1A0C5&partner_uuid=${ptValue}`)
      .then((res) => {
        console.log(res.data)
        setDataFilter(res.data)

        // console.log(res.data[0], "resres")
      })
      .catch((err) => {
        console.log(err)
      })
  }, [arValue, areaVal, ptValue])
  // http://test-api.doctall.com/api/v1/uploadDoc/labpartner/details?area_uuid=AR-DFD9991F&city_uuid=CY-25F1A0C5&partner_uuid=PTN-18E0687B
  useEffect(() => {
    if (filtrdata && filtrdata.length !== 0) {
      let res = filtrdata.map((e, i) => {
        return { label: e.partner_name, value: e.partner_uuid };
      });
      setPartners(res);
    }
  }, [filtrdata]);

  var array3 = [];

  // for (var i = 0; i < partner.length; i++) {
  //   for (var y = 0; y < filtrdata.length; y++) {
  //     if(partner[i].uuid === filtrdata[y].partner_uuid){
  //       array3.push(partner[i])
  //     }
  //   }
  // }

  partner && partner.map((item) => {
    filtrdata && filtrdata.map((items) => {
      if (item.uuid === items.partner_uuid) {
        console.log(item)
        array3.push(item)
      }
    })
  })

  return (
    <>
      <Grid container>
        <Grid xs={12}>
          <h5 className="Find">Find the nearest partner location to you</h5>
        </Grid>
        <Grid container className="varun" style={{ gap: "20px" }}>
          <Grid xs={3}>
            <DropDown
              placeholder={"Select City"}
              onChange={(e) => {
                handlearea(e.target);
                console.log(e.target, "fghj")
                setAreaVal(e.target.value);
                setCityName(e.target.label)
                setArValue("");
                setPtValue("");
                // setArValue(null);
                // dispatch(areaValue(null));

              }}
              value={areaVal}
              options={city && city.length !== 0 ? city : []}
              arrowStyle={{
                background: "#9CA3AF",
              }}
            />
          </Grid>
          <Grid xs={3}>
            <DropDown
              placeholder={"Select Area"}
              onChange={(e) => {
                setArValue(e.target.value);
                setAreaName(e.target.label)
                dispatch(areaValue(e.target));
              }}
              value={arValue}
              options={area && area.length !== 0 ? area : []}
              arrowStyle={{
                background: "#9CA3AF",
              }}
            />
          </Grid>
          <Grid xs={3}>
            <DropDown
              placeholder={"Select Partner"}
              onChange={(e) => {
                setPtValue(e.target.value);
                // console.log(e.target.value);
              }}
              value={ptValue}
              options={partners && partners.length !== 0 ? partners : []}
              arrowStyle={{
                background: "#9CA3AF",
              }}
            />
          </Grid>
        </Grid>

      </Grid>
      <hr className="line" />
      {/* {console.log(filtrdata.length,"filtrdata.length")} */}
      {/* {console.log(arValue,"dfghj")} */}
      {filtrdata.length > 0 ?
        <div>
          {[...new Set(array3)].map((item) => {

            return <>
              {/* {console.log(Array(item),"item.logo")} */}
              {/* <div className="modal_subhead">

                {areaVal !== (undefined || null || '') && arValue !== (undefined || null || '') && ptValue !== (undefined || null || '')? 
                  <>
                  <label>{filtrdata && filtrdata.length}</label>
                  <span>
                   {`Please find the different addresses of our Lab partner in ${cityName}, ${areaName} below`}
                  </span>
                  </>
                :
                ''
                }
              </div> */}
              <div className="modal_header">
                <img src={item.logo} style={{ textAlign: "center", width: "120px", height: "auto" }}></img>
              </div>
              <div className="modal_subhead">
                {areaVal !== (undefined || null || '') && arValue == (undefined || null || '') ?
                  <span>
                    {`Please find the different addresses of our Lab partner in ${cityName} below`}
                  </span>
                  :
                  ''
                }
                {areaVal !== (undefined || null || '') && arValue !== (undefined || null || '') ?
                  <span>
                    {`Please find the different addresses of our Lab partner in ${cityName}, ${areaName} below`}
                  </span>
                  :
                  ''
                }
              </div>
              {/* <Card> */}

              {/* <label>{Array(item).length} locations found for <label style={{color:"#0747A6"}}>{item.name}</label></label> */}
              <Grid container style={{ marginTop: "10px", marginLeft: "10px", marginBottom: "10px" }} xs={12}>
                {filtrdata.map((item1) => {
                  if (item.name == item1.partner_name) {
                    // setLocationLength(Array(item).length)
                    return <Grid xs={4} >
                      <Card style={{ width: "90%", height: "150px", overflow: "auto", marginBottom: "10px" }}>
                        <h2 style={{ marginLeft: "20px", }}>{item1.city}</h2>
                        <label style={{ marginLeft: "20px" }}>{item1.address}</label>
                      </Card>
                    </Grid>
                  }
                })}

              </Grid>
              {/* </Card> */}
            </>
          })}
        </div>

        :

        <div>
          <h4 className="Find1">Meet our partners</h4>
          <p className="Text">
            We work with partners to deliver best quality medical services at cheaper than market rates<br /><br />

            See the spread of all our partner services in 170 locations"
          </p>
        </div>
      }



    </>
  )
}